/**
 * @desc: - 投注选号 - 全/大/小/奇/偶/清操作
 * @param  {[STRING]} className：   [顶层 class]
 * @param  {[STRING]} mname:        [玩法中文名称：区分三同号通选，三连号通选]
 * @param  {[STRING]} values:       [当前选中值，只能是'通选'或空]
 * @param  {[FUNCTION]} onChange:   [变更时候的方法]
 * @author: klaf
 */
export default class BetDiceSame extends React.Component {

	constructor(props) {
		super(props);
	}

	// 点击
	handleClick(){
    const {values, onChange} = this.props;
    let result = (values[0]=='通选'?'':['通选'])
    onChange(result);
	}

	render() {
		const {className, mname, values, onChange} = this.props;

    return (
      <div className={className?className:'lotteryView_k3'}>
        <div className="h150">
          <ul>
            {
              ( 
                mname.indexOf('三同号') > -1
                  ?
                <li className={values[0]=='通选'?'hover w800':'w800'} onClick={this.handleClick.bind(this)}>
                  <em>通选</em>
                  <div className="triple"><span className="s1 mar"></span><span className="s1"></span><span className="s1"></span><p>111</p></div>
                  <div className="triple"><span className="s2 mar"></span><span className="s2"></span><span className="s2"></span><p>222</p></div>
                  <div className="triple"><span className="s3 mar"></span><span className="s3"></span><span className="s3"></span><p>333</p></div>
                  <div className="triple"><span className="s4 mar"></span><span className="s4"></span><span className="s4"></span><p>444</p></div>
                  <div className="triple"><span className="s5 mar"></span><span className="s5"></span><span className="s5"></span><p>555</p></div>
                  <div className="triple"><span className="s6 mar"></span><span className="s6"></span><span className="s6"></span><p>666</p></div>
                </li>
                  :
                <li className={values[0]=='通选'?'hover w800':'w800'} onClick={this.handleClick.bind(this)}>
                  <em>通选</em>
                  <div className="triple"><span className="s1 mar"></span><span className="s2"></span><span className="s3"></span><p>123</p></div>
                  <div className="triple"><span className="s2 mar"></span><span className="s3"></span><span className="s4"></span><p>234</p></div>
                  <div className="triple"><span className="s3 mar"></span><span className="s4"></span><span className="s5"></span><p>345</p></div>
                  <div className="triple"><span className="s4 mar"></span><span className="s5"></span><span className="s6"></span><p>456</p></div>
                </li>
              )
            }
          </ul>
        </div>
      </div>
    )
	}
}
